import { FaCheckCircle } from "react-icons/fa";
import { ListItemStyled } from "../styles/inputForms.styled";

const ListItem = ({ children }) => {
  return (
    <>
      <ListItemStyled>
        <FaCheckCircle />
        <p>{children}</p>
      </ListItemStyled>
    </>
  );
};

export default ListItem;
